import '../../../../src/assets/stylus/ui/_dataGrid.scss'
import { h } from 'vue'

export default {
  name: 'j-data-grid-tool-bar',
  props: {
    headers: { type: Array, default: () => [] },
    items:   { type: Array, default: () => [] },
  },
  methods: {
    genHeader() {
      const len = this.headers.length
      if (len === 0) return null

      const toolbarSlot = this.$slots['tool-bar']
      const hasToolbar   = !!toolbarSlot
      const rows = []

      // ────────────── 툴바 행 ──────────────
      if (hasToolbar) {
        // 설정 아이콘
        const gearButtons = this.headers[0].type === 'conf'
          ? [
              h('button',
                {
                  class: 'jcon_config',
                  onClick: e => this.$emit('click-config', e)
                }
              )
            ]
          : []

        // 첫 번째 <th> (config)
        rows.push(
          h('tr', null, [
            h('th', { class: 'column text-center' }, gearButtons),
            // colspan: len-1
            h('th', { colspan: len - 1 }, toolbarSlot())
          ])
        )
      }

      // ────────────── 헤더 타이틀 행 ──────────────
      const headerCells = this.headers.map(header => {
        const style = header.width
          ? {
              width:    `${header.width}px`,
              maxWidth: `${header.width}px`,
              minWidth: `${header.width}px`
            }
          : {}

        return h('th',{ style },hasToolbar ? '' : header.text)
        
      })
      // 높이 0 으로 숨길 때
      const trStyle = hasToolbar ? { height: '0' } : {}
      rows.push(h('tr', { style: trStyle }, headerCells))

      return h('thead', null, rows)
    },

    genBody() {
      const itemSlot = this.$slots.items
      if (!itemSlot) return h('tbody')

      // 슬롯 호출 결과가 VNode 배열이므로 flatten
      const rows = this.items.flatMap((item, idx) =>
        itemSlot({ item, index: idx })
      )

      return h('tbody', null, rows)
    }
  },
  render() {
    return (
      <div class="j_datagrid chart">
        <div class="v-table__wrapper">
          <table class="v-datatable v-table v-theme--light">
            { this.genHeader() }
            { this.genBody() }
          </table>
        </div>
      </div>
    )
  }
}